import React from "react";
import PageContent from "../../../common/components/atom/PageContent/PageContent";
import SectionTitle from "../../../common/components/atom/SectionTitle/SectionTitle";
import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import SingleClient from "../../../features/clients/components/SingleClient";
import TextBox from "../../../common/components/molecule/TextBox/TextBox";

import { Wallet } from "../../../features/wallet/types/wallet.types";
import useNavigationApp from "../../../navigation/useNavigationApp";
import { JWayIcon } from "../../../common/assets/JWayIcons";
import SinglePayGoModal from "../../../features/paygo/components/SinglePayGo/SinglePayGoModal/SinglePayGoModal";
import SinglePaygoPage from "../../PaygoPages/SinglePaygoPage/SinglePaygoPage";
import { numberFormaterString } from "../../../utils/numberFormater";

export default function SingleClientExtendPage() {
  const navigtion = useNavigationApp();
  return (
    <PageContent>
      <HeaderTitleContent withGoBackBtn>
        <SingleClient.InfoExtend info="client_firstname" />{" "}
        <SingleClient.InfoExtend info="client_lastname" />
      </HeaderTitleContent>
      <div style={{ display: "flex", gap: 20, height: "250px" }}>
        <TextBox
          style={{ height: "100%" }}
          content={[
            {
              title: "Nom",
              TextRender: () => (
                <SingleClient.InfoExtend info="client_lastname" emptyText="Aucun" />
              ),
            },
            {
              title: "Prénom",
              TextRender: () => (
                <SingleClient.InfoExtend info="client_firstname" emptyText="Aucun" />
              ),
            },

     

            {
              title: "Statut",
              TextRender: () => (
                  <SingleClient.InfoExtend info="user_orga_status" emptyText="Aucun" styled/>
              ),
            },
          ]}
        />
        <TextBox
          content={[
            {
              title: "Email",
              TextRender: () => <SingleClient.InfoExtend info="client_email" />,
            },
            {
              title: "Téléphone",
              TextRender: () => (
                <SingleClient.InfoExtend
                  info="client_phone_number"
                  emptyText="Aucun"
                />
              ),
            }
          ]}
        />
      </div>

      <div style={{ height: 50 }} />

      <SingleClient.InfoExtend
        info="walletList"
        renderComponent={({ labelRender, goTo, item }) => {
          const itemTyped = item as Wallet[];
          return (
            <>
              {itemTyped?.map((wallet) => (
                <TextBox
                  style={{ height: "150px", width: "clamp(150px, 50%, 300px)" }}
                  content={[
                    {
                      title: "Portefeuille",
                      ItemRender: () => (
                        <p
                          style={{
                            fontSize: "clamp(2rem, 2.5vw, 3rem)",
                            display: "flex",
                            margin: 0,
                            padding: 0,
                          }}
                        >
                          {numberFormaterString(wallet.wallet_amount)}{" "}
                          <span
                            style={{
                              fontSize: "0.9rem",
                              marginTop: "10px",
                              marginLeft: "10px",
                            }}
                          >
                            {wallet.wallet_currency}
                          </span>
                        </p>
                      ),
                      LeftIconRender: () => (
                        <JWayIcon
                          type="wallet"
                          size={15}
                          color="rgb(162, 162, 162)"
                        />
                      ),
                    },
                  ]}
                  labelBtn="Voir"
                  onClick={() =>
                    navigtion.goToClientWallet(
                      wallet.wallet_user_orga_id,
                      wallet.wallet_id
                    )
                  }
                />
              ))}
            </>
          );
        }}
      />
      <div style={{ height: "50px" }} />
      <SectionTitle iconType="coin">Liste des PayGo</SectionTitle>
      <SingleClient.InfoExtend info="paygolist" />
      <SinglePayGoModal>
        <SinglePaygoPage />
      </SinglePayGoModal>
    </PageContent>
  );
}
